import { createFileRoute } from '@tanstack/react-router';

import { DataIntegrationsPage } from '@/areas/settings/part-intelligence/Settings/DataIntegrationsPage/DataIntegrationsPage';
import { canViewDataIntegrationsSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/data-integrations')({
    staticData: { access: { permissions: canViewDataIntegrationsSettings }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <DataIntegrationsPage />;
}
